




























































import {Component, Prop, Vue} from 'vue-property-decorator';
import {HTML_SERVICE_INSTANCE} from '@/services/html.service';
import {DIALOG_STACK_INSTANCE, DialogInstance} from '@/utils/dialog.stack';
import {FormularInstance} from '@/views/formular/form.interface';

export interface ConfirmationDialogButton {
  title: string;
  text: string;
  loading: boolean;
  disabled: boolean;
  onClick: (button: ConfirmationDialogButton, event: Event, formularInstance?: FormularInstance) => void;
  autoFocus?: boolean;
}

export interface ConfirmationDialogConfig {
  title?: string;
  headerColor?: 'primary' | 'secondary';
  message: string;
  formular?: DisguiseDto.FTDefinitionDto;
  buttons: ConfirmationDialogButton[];
  onEsc: (event: Event) => void;
  closeButton?: ConfirmationDialogCloseButton;
}

export interface ConfirmationDialogCloseButton {
  onClick: (event: Event) => void;
  title?: string;
}

@Component({
  components: {
    LazyFormTemplate: () => import('./formular/FormTemplate.vue'),
  },
  name: 'advanced-confirm-dialog'
})
export default class AdvancedConfirmDialog extends Vue implements DialogInstance {

  @Prop() confirmationDialogConfig!: ConfirmationDialogConfig;
  hideOverlay: boolean = false;

  formularInstance: FormularInstance | null = null;

  $refs!: {
    dialogBtn: Vue
  };

  mounted() {
    DIALOG_STACK_INSTANCE.registerDialog(this);
    Vue.nextTick(() => {
      // focus first autoFocus btn
      if (this.$refs.dialogBtn) {
        let autoFocusTargets;
        if (Array.isArray(this.$refs.dialogBtn)) {
          autoFocusTargets = this.$refs.dialogBtn;
        } else {
          autoFocusTargets = [this.$refs.dialogBtn];
        }

        for (const currentPossibleTarget of autoFocusTargets) {
          if (currentPossibleTarget.$attrs.autofocus === true) {
            HTML_SERVICE_INSTANCE.focusFirstNode(currentPossibleTarget.$el);
            break;
          }
        }
      }
    });
  }

  destroyed() {
    DIALOG_STACK_INSTANCE.unregisterDialog(this);
  }

  shouldHideOverlay(): void {
    this.hideOverlay = true;
  }

  shouldRestoreHideOverlay(): void {
    this.hideOverlay = false;
  }

  afterFormularInitialized(formularInstance: FormularInstance) {
    this.formularInstance = formularInstance;
  }

}
